import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ResponsiveService } from '../../../services/responsive.service';
import { ViewPath } from '../../../constants/ViewPath';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GoDirective } from '../../../directives/go.directive';
import { IconFilledDirective } from '../../../directives/icon-filled.directive';
import { MenuItemInterface, MenuService } from '../../../services/menu.service';
import { HasPermissionDirective } from '../../../directives/has-permission.directive';
import { PermissionsEnum } from '../../../enums/PermissionsEnum';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    IconFilledDirective,
    RouterModule,
    GoDirective,
    HasPermissionDirective,
    MatMenuModule,
    MatButtonModule,
    NgClass,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class MenuItemComponent implements OnInit {
  @ViewChild('item') item!: ElementRef<HTMLDivElement>;
  @Input() menuItemPermissions!: PermissionsEnum | PermissionsEnum[];
  @Input() data!: MenuItemInterface;
  @Input() isDesktopMenu!: boolean;
  @Input() menuOpened!: boolean;
  @Input() matmenu: boolean = false;
  @Input() class_: string | undefined;
  @Input() righticon: { icon: string; color: string } | undefined = undefined;
  @Input() svgIcon = false;
  @Input() showAttentionDot: boolean = false;
  @Output() afterGo = new EventEmitter<void>();

  // Constructor (inyeccion dependencias angular)
  menuS = inject(MenuService);
  responsive = inject(ResponsiveService);

  ngOnInit(): void {}

  get attentionIcon() {
    if (!this.data) {
      return false;
    }
    if (this.showAttentionDot) {
      return true;
    }
    return false;
  }

  getSvgIconName(): string {
    // Si no hay data o icon, retorna un string vacío
    if (!this.data?.icon) {
      return '';
    }

    const isSelected = this.menuS.isSelected(this.data);
    const icon = this.data.icon;

    if (isSelected) {
      return icon;
    }

    // Si no está seleccionado y es 'wheel', usa la versión _outline
    if (icon === 'wheel') {
      return `${icon}_outline`;
    }

    return icon;
  }

  dataClassPhoneDesktop() {
    var isPhone = this.responsive.isPhone();
    if ((this.isDesktopMenu && isPhone) || (!this.isDesktopMenu && !isPhone)) {
      return '';
    }
    return this.data.class_;
  }

  animation() {
    this.item.nativeElement.classList.toggle('selected');
  }

  get isShowing() {
    if (this.data) {
      return this.menuS.havePermisisons(this.data.view);
    }
    return false;
  }

  onAfterGo() {
    this.afterGo.emit();
  }
}
